export const CELL_RENDERER = {
  TEXT: "SFCellTextRenderer",
  EDIT_CLICKABLE: "SFEditRenderer",
};

export const HEADER_RENDERED = {
  DEFAULT: "SFColumnHeaderRenderer",
};

export const FILTER_TYPES = {
  DROPDOWN: "dropdown",
  BOOLEAN: "boolean",
  CATEGORY: "category",
  HIERARCHY: "hierarchy",
  NUMBER: "agNumberColumnFilter",
  DATE: "agDateColumnFilter",
  RADIO: "radio",
};

export const GRID_ACTION = {
  ADD: 1,
  EDIT: 2,
  DELETE: 3,
  RESTORE: 4,
  NAVIGATE: 5,
};

export const GRID_FILTERS = {
  filterType: {
    set: "set",
    number: "number",
    groupTreeFilter: "groupTreeFilter",
    date: "date",
  },
  type: {
    equals: "equals",
    notEqual: "notEqual",
    lessThan: "lessThan",
    lessThanOrEqual: "lessThanOrEqual",
    greaterThan: "greaterThan",
    greaterThanOrEqual: "greaterThanOrEqual",
    inRange: "inRange",
    blank: "blank",
    notBlank: "notBlank",
  },
  operator: { and: "AND", or: "OR" },
};

export const GRID_SORTINGS = {
  ASC: "asc",
  DESC: "desc",
};

export const GRID_OPTIONS = {
  SERVER_SIDE_DATASOURCE: "serverSideDatasource",
  DOM_LAYOUT: "domLayout",
};
